import axiosInstance from "@/api/axiosInstance";

export interface WidgetUser {
  id: string;
  firstName: string | null;
  lastName: string | null;
  email: string | null;
  createdAt: string;
  updatedAt: string;
  widget: {
    id: number;
    key: string;
    color: string;
  };
  isOnline?: boolean;
  unreadMessageCount?: number;
  status?: "online" | "offline";
  avatar?: string;
  unread?: number;
  lastMessage?: {
    text: string;
    images?: string[];
    createdAt?: string;
  };
}

export interface ChatUsersResponse {
  data: WidgetUser[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
  totalUnreadCount?: number;
}

export const chatService = {
  getChatUsers: async (
    params: { page?: number; limit?: number } = {}
  ): Promise<ChatUsersResponse> => {
    const response = await axiosInstance.get<ChatUsersResponse>(
      "/company/widget-users",
      {
        params: {
          page: params.page || 1,
          limit: params.limit || 30,
        },
      }
    );
    return response.data;
  },

  getChatUserMessagesById: async (
    id: string,
    params: { page?: number; limit?: number } = {}
  ): Promise<any> => {
    const response = await axiosInstance.get<any>(
      `company/widget-users/${id}/messages`,
      {
        params: {
          page: params.page || 1,
          limit: params.limit || 30,
        },
      }
    );
    return response?.data || { data: [], meta: {} };
  },
};
